import RequireRole from './RequireRole'
import { KEYCLOAK_ROLES } from 'helpers/constants'

export default function RequireAgent({ children }: { children: JSX.Element }) {
  return (
    <RequireRole roles={[KEYCLOAK_ROLES.ROLE_AGENT]}>{children}</RequireRole>
  )
}
